import React, { useEffect, useState } from 'react';
import Moment from "moment";
import 'chartjs-plugin-datalabels';
import { Card, CardBody, CardTitle, Col,  Row } from "reactstrap";

import AppRequestLogDashboardFilters from "./_filters";
import { showLoader } from "../../../components/loader/loader";
import { showToastCustom } from "../../../components/toast/customToast";
import { error } from "../../../components/i18n/i18n";
import { CardChartBar } from "../../../components/charts/ChartBar";
import {getFirstDayOfMonth, getLastDayOfMonth } from "../../../util/DateTools";
import {logHistoryService} from "../../../jwt/_services/security/logHistoryService";

export default function LogHistoryDashboard() {
    const [loading, setLoading] = useState(false);
    const today = new Date()

    const [dataFilter, setDataFilter] = useState({
        from : Moment( getFirstDayOfMonth(today.getFullYear(), today.getMonth()) ).format('yyyy-MM-DD 00:00:00'),
        to :   Moment(  getLastDayOfMonth(today.getFullYear(), today.getMonth()) ).format('yyyy-MM-DD 23:59:59'),
    });

    const [byUser, setByUser] = useState(null);
    const [byUserRawData, setByUserRawData] = useState(null);

    const [ totalRegs, setTotalRegs] = useState(0);


    useEffect(() => {
        refreshDashboard(dataFilter);
    }, []);

    const refreshFiltered = (_dataFilter) => {
        setDataFilter(_dataFilter);
        refreshDashboard(_dataFilter);
    }

    const refreshDashboard = ( _dataFilter ) => {
        setLoading(true);
        logHistoryService.searchDashboard( _dataFilter)
            .then(result => {
                if (result){

                    if (result?.users !== null)
                        setByUser(mapByUser(result?.users));

                    if (result?.changes !== null) {
                        setTotalRegs(setTotalChangesFromResult(result?.changes));
                    }

                } else {
                }
                setLoading(false);
            })
            .catch(errorMessage => {
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
    }

    const setTotalChangesFromResult = (changes) => {
        if (changes) {
            const firstKey = Object.keys(changes)[0]; // Obtiene la primera clave del objeto
            return (changes[firstKey]?.cant || 0)  // Establece totalRegs con el valor de cant
        }
    };

    const mapByUser = (_byUser) => {
        const _labels = _byUser.map(item => item.label);
        const _values = _byUser.map(item => parseInt(item.value, 10));

        let output = {}
        _labels.forEach((item, index) => {
            output = { ...output, [_labels[index]]: _values[index] }
        })
        setByUserRawData([output])

        return {
            labels: _labels,
            datasets: [
                {
                    label: '',
                    data: _values,
                    borderColor: 'rgb(13,0,132)',
                    backgroundColor: 'rgba(0,80,145,0.75)',
                    borderWidth: 1,
                }
            ],
        };
    }

    return (
        <div>
            {loading && showLoader()}
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>
                </CardTitle>
                <AppRequestLogDashboardFilters refreshFiltered={refreshFiltered} />
                <CardBody>
                    <Row className={'mb-2em'}>
                        <h3>{`Total:`}</h3>
                        <br />
                        <Col>
                            <h2>{ totalRegs }</h2>
                        </Col>
                    </Row>
                    <Col className='col-md-12'>
                        {
                            byUser != null && <CardChartBar
                                title='Cantidad de solicitudes por dia del mes'
                                rawData = { byUserRawData }
                                graphicData={ byUser }
                            />
                        }
                    </Col>
                    <br/><br/><br/>
                </CardBody>
            </Card>
        </div>
    );
}